











































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { NotificationsApi, Notification } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';

import Pane from '@/layout/pane.vue';
import NotificationList from '@/components/NotificationPane/NotificationList/index.vue';
import NotificationModule from '@/store/modules/notification';
import UIModule from '@/store/modules/ui';

@Component({
  components: {
    Pane,
    NotificationList,
  },
})
export default class NotificationPane extends Vue {
  notifications: Notification[] = [];

  mounted() {
    this.getNotifications();
  }

  public async getNotifications() {
    this.notifications = NotificationModule.notifications;
  }

  public async markAllAsRead() {
    NotificationModule.UPDATE_READ_ALL();
    const notificationsApi = new NotificationsApi(AppModule.apiConfig);
    const readNotifications = await notificationsApi.updateNotifications(this.notifications);
  }

  get numberOfUnread() {
    return NotificationModule.unreadCount;
  }

  get recentNotifications() {
    if (!this.notifications) {
      return [];
    }
    return this.notifications.filter(n => moment(n.createdAt).isAfter(moment().startOf('day')))
      .sort((a, b) => -(a.createdAt as string)
        .localeCompare(b.createdAt as string));
  }

  get yesterdayNotifications() {
    if (!this.notifications) {
      return [];
    }
    return this.notifications.filter(n => moment(n.createdAt).isBefore(moment().startOf('day')) && moment(n.createdAt).isAfter(moment().subtract(1, 'days').startOf('day')))
      .sort((a, b) => -(a.createdAt as string)
        .localeCompare(b.createdAt as string));
  }

  get olderNotifications() {
    if (!this.notifications) {
      return [];
    }
    return this.notifications.filter(n => moment(n.createdAt).isBefore(moment().subtract(1, 'days').startOf('day')))
      .sort((a, b) => -(a.createdAt as string)
        .localeCompare(b.createdAt as string));
  }

  get pane() {
    return UIModule.pane;
  }

  set pane(v) {
    UIModule.SET_PANE(v);
  }

  togglePane() {
    this.pane = !this.pane;
  }
}
